export default __webpack_public_path__ + "static/media/onboarding_organize_ad_1.2b8daf99.png";